import { ActivityFilters } from "@/components/filters/ActivityFilters";
import { Button } from "@/components/ui/button";
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarGroup,
  SidebarGroupContent,
  SidebarHeader,
  SidebarRail,
  useSidebar,
} from "@/components/ui/sidebar";
import { useIsMobile } from "@/hooks/use-mobile";
import { appModeAtom } from "@/state/app.state";
import { useAtomValue } from "jotai";
import { X } from "lucide-react";
import { Link } from "react-router-dom";
import { DemoProfile } from "./DemoProfile";
import { Profile } from "./Profile";

export function AppSidebar() {
  const mode = useAtomValue(appModeAtom);
  const isMobile = useIsMobile();
  const { setOpenMobile } = useSidebar();

  return (
    <Sidebar collapsible="icon">
      <SidebarHeader className="gap-2">
        <div className="flex items-center justify-between p-3 md:p-4">
          <Link
            to="/home"
            className="min-w-0 cursor-pointer focus:outline-none focus:ring-2 focus:ring-ring rounded-sm"
          >
            <div className="truncate text-sm font-semibold">Stratistics</div>
          </Link>

          {isMobile && (
            <Button
              variant="ghost"
              size="icon"
              aria-label="Close sidebar"
              onClick={() => setOpenMobile(false)}
            >
              <X className="h-4 w-4" />
            </Button>
          )}
        </div>
      </SidebarHeader>

      <SidebarContent>
        <SidebarGroup className="flex-1 min-h-0 group-data-[collapsible=icon]:hidden">
          <SidebarGroupContent className="my-auto min-h-0 overflow-y-auto">
            <ActivityFilters variant={isMobile ? "mobile" : "sidebar"} />
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>

      <SidebarFooter className="pb-[var(--safe-bottom)]">
        {mode === "authed" ? <Profile /> : <DemoProfile />}
      </SidebarFooter>

      <SidebarRail />
    </Sidebar>
  );
}
